import BugNoteRepositoryInterface from '@/services/Bug-report/Bug-report/Notes/interfaces';
import { AxiosInstance } from 'axios';
import { BugReportNoteEntity } from '@fenix/bug-report-entities/bug-report-entities';

export default class BugNoteRepository implements BugNoteRepositoryInterface {
  constructor(private readonly axios: AxiosInstance) {
  }

  public async createNote(bugReportId: number, body: string): Promise<BugReportNoteEntity> {
    const url = `bug-report/bugs/${bugReportId}/note`;
    const res = await this.axios.post(url, { body });
    return res.data;
  }

  public async getAll(bugReportId: number, page?: number, take?: number, desc?: boolean): Promise<BugReportNoteEntity[]> {
    const url = `bug-report/bugs/${bugReportId}/note?page=${page}&take=${take}&desc=${desc}`;
    const res = await this.axios.get(url);
    return res.data;
  }
}
